import { FC } from 'react';
import { FallbackProps } from 'react-error-boundary';
import logoWhite from '@brand/logo-white.svg';
import UiErrorPage from '@srm/ui/shell/ErrorPage';

// Страница живёт в @srm/ui; логотип — из ассетов Front.
const ErrorPage: FC<FallbackProps> = (props) => <UiErrorPage {...props} logoSrc={logoWhite} />;

export default ErrorPage;
